<template>
  <vk-modal :size="isFullScreen ? 'modal-full-screen' : ''" :show.sync="isOpen" :stuck="stuck" ref="modal">
    <vk-modal-title slot="header">{{title }}</vk-modal-title>
    <slot/>
    <div slot="footer" class="uk-text-right">
      <vk-button v-if="showCancelButton" class="uk-margin-small-right" @click.prevent="close">{{ cancelText }}</vk-button>
      <vk-button v-if="showOkButton" type="primary" @click.prevent="onConfirm">{{ confirmText }}</vk-button>
    </div>
  </vk-modal>
</template>

<script>
export default {
  name: "ModalDialog",
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
    stuck: {
      type: Boolean,
      default: false,
    },
    cancelText: {
      type: String,
      default: 'Cancel',
    },
    confirmText: {
      type: String,
      default: 'Ok',
    },
    customData: {
      type: Object,
      default: {},
    },
    showCancelButton: {
      type: Boolean,
      default: true,
    },
    showOkButton: {
      type: Boolean,
      default: true,
    },
    isFullScreen: {
      type: Boolean,
      default: false,
    },
    closeOnConfirm: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      isOpen: false,
      prevFocus: null,
    }
  },
  watch: {
    show(newValue) {
      this.isOpen = newValue;
    },
  },
  mounted() {
    this.isOpen = this.show;
  },
  methods: {
    open() {
      console.log('opening');
      this.isOpen = true;
      this.prevFocus = document.querySelector(':focus');
      setTimeout(() => {
        const focusableElements = (UIkit.Utils || UIkit.util).findFocusables(this.$refs.modal.$el)
        if (focusableElements.length > 0) {
          focusableElements[0].focus()
        }
      }, 500)
    },
    close() {
      this.isOpen = false;
      this.prevFocus && this.prevFocus.focus();
      this.$emit('close', this.customData);
    },
    onConfirm() {
      this.$emit('confirm', this.customData);
      if(this.closeOnConfirm) {
        this.isOpen = false;
      }
      this.prevFocus && this.prevFocus.focus();
    },
    setData(obj) {
      this.customData = obj;
    }
  },
}
</script>

<style lang="scss">
  .uk-width-modal-full-screen {
    max-width: 1398px !important;
    width: 100%;
  }
</style>
